<template>
  <div id="app">
    <HeaderBar pageName="rebuild"></HeaderBar>
    <div v-show="isIntroducingShow" class="forewords">
      <div class="foreword-content-step1 foreword-content">
        <p :class="{'fixIOS': isIOS}">921震碎許多人的家園，<br>
        卻也震出社區重建的契機。</p>
      </div>
      <div class="foreword-content-step2 foreword-content">
        <p :class="{'fixIOS': isIOS}">有一群人在災區堅持二十年，<br>
        走出一條自立自強的重建路。</p>
      </div>
      <div class="foreword-content-step3 foreword-content">
        <div class="beforeVideo">
          <p :class="{'fixIOS': isIOS}">走一趟921重生之旅</p>
          <div class="videoStatus">
            <div class="videoStatus2 loading" v-show="isBeforeLoading === true && videoStatus === 1">

            </div>
            <div class="videoStatus3 playVideo" @click="playVideo" v-show="isBeforeLoading === false && videoStatus === 2">
              <ScrollDownArrow></ScrollDownArrow>
              <div class="startPlay">點擊開始</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="isVideoShow" class="video-box">
      <video
        ref="video"
        width="100vw"
        id="coverVideo"
        :src="srcRWD('https://p3.udn.com.tw/921/rebuild/rebuild_vmob1.mp4', 'https://p3.udn.com.tw/921/rebuild/rebuild_vpc1.mp4')"
        :poster="srcRWD('https://p3.udn.com.tw/921/rebuild/rebuild_vmob_bg2.jpg', 'https://p3.udn.com.tw/921/rebuild/rebuild_vpc_bg2.jpg')"
        :class="{'fixIE': isIE}"
        preload
        autobuffer
        muted
        playsinline>
      </video>
      <div class="skip" @click="handleSkipVideo('isPlaying')" >略過影片</div>
    </div>
     <transition name="fade">
      <div v-show="isMenuShow" class="menu">
        <h5>921大地震廿周年</h5>
        <h1>重建與重生</h1>
        <h6 class="readMore">點按看故事</h6>
        <ul class="theme-lists">
          <!-- <li class="theme-list" @mouseover="handelMouseIn(index)" @mouseleave="handelMouseOut(index)" :class="[{'active': item.isActive}, item.class]" :key="index" v-for="(item, index) in nav"> -->
          <li @click="handleOutlinkGA(index)" class="theme-list"  @mouseover="handelMouseIn(index)" @mouseleave="handelMouseOut(index)" :class="[{'active': item.isActive}, item.class]" :key="index" v-for="(item, index) in nav">
            <a target="_blank" :href="item.link">
              <span class="theme-list-content"><span class="mark" :class="[{fixSAMSUNG: isSAMSUNG}, {fixIOS: isIOS} ,{fixIE: isIE },item.class + '-mark']"></span>{{ item.name }}</span>
            </a>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import Utils from 'udn-newmedia-utils'
import anime from 'animejs'
import srcRWD from './mixin/srcRWD.js'
import { setTimeout } from 'timers';
import ScrollDownArrow from './components/ScrollDownArrow.vue'
import HeaderBar from '../../general_components/HeaderBar.vue'

export default {
  name: 'app',
  data () {
    return {
      t1: null,
      t2: null,
      t3: null,
      t4: null,
      isSAMSUNG: false,
      isIE: false,
      isIOS: false,
      isMenuPlay: false,
      isIntroducingShow: true,
      isVideoShow: false,
      isBeforeLoading: true,
      isMenuShow: false,
      videoStatus: 0,
      videoProcess: [false, false, false, false, false],
      currentRangeName: ['0-3 second', '4-6 second', '7-9 second', '10-12 second', '13-15 second'],
      nav: [{
        name: '桃米村重生記',
        class: 'theme-list1',
        link: './liao/',
        isActive: false
      },{
        name: '廢墟中的金牌',
        class: 'theme-list2',
        link: './huang/',
        isActive: false
      },{
        name: '獨老者桃花源',
        class: 'theme-list3',
        link: './tzu/',
        isActive: false
      },{
        name: '偏鄉閱讀推手',
        class: 'theme-list4',
        link: './cheng/',
        isActive: false
      },{
        name: '藍染的一片天',
        class: 'theme-list5',
        link: './yeh/',
        isActive: false
      },{
        name: '回首廿年重建路',
        class: 'theme-list6',
        link: './hsieh/',
        isActive: false
      }]
    }
  },
  components: {
    ScrollDownArrow,
    HeaderBar
  },
  mixins: [srcRWD],
  mounted () {
    this.handleIntro()
    this.detactVideoStatus()
    this.handleIOS()
    this.detactIE()
    this.detactSAMSUNG()
  },
  methods: {
    detactSAMSUNG() {
      if(navigator.userAgent.match(/SAMSUNG|SGH-[I|N|T]|GT-[I|P|N]|SM-[N|P|T|Z|G]|SHV-E|SCH-[I|J|R|S]|SPH-L/i))  {
        this.isSAMSUNG = true
      } else {
        this.isSAMSUNG = false
      }
    },
    detactIE() {

        if (document.documentMode || /Edge/.test(navigator.userAgent)) {
          this.isIE = true
        } else {
           this.isIE = false
        }
    },
    handleIntro () {
      // Create a timeline with default parameters
      let vm = this
      let tl = anime.timeline({
        easing: 'easeOutExpo',
      });

      // Add children
      tl
      .add({
        targets: '.foreword-content-step1',
        opacity: 1,
        duration: 2000,
        scale: 1.024,
        begin: function() {
          document.querySelector(".foreword-content-step1").style.display = "block";
        }
      })
      .add({
        targets: '.foreword-content-step1',
        opacity: 1,
        scale: 1.03,
        duration: 1000
      })
      .add({
        targets: '.foreword-content-step1',
        opacity: 0,
        duration: 500,
        complete: function() {
          document.querySelector(".foreword-content-step1").style.display = "none";
        }
      })
      .add({
        targets: '.foreword-content-step2',
        opacity: 1,
        scale: 1.024,
        duration: 2000,
        begin: function() {
          document.querySelector(".foreword-content-step2").style.display = "block";
        }
      })
      .add({
        targets: '.foreword-content-step2',
        scale: 1.03,
        duration: 1000
      })
      .add({
        targets: '.foreword-content-step2',
        opacity: 0,
        duration: 500,
        complete: function() {
          document.querySelector(".foreword-content-step2").style.display = "none";
        }
      })
      .add({
        targets: '.foreword-content-step3',
        opacity: 1,
        scale: 1.024,
        duration: 2000,
        begin: function() {
          document.querySelector(".foreword-content-step3").style.display = "block";
        }
      })
      .add({
        targets: '.foreword-content-step3',
        scale: 1.03,
        duration: 1000,
        complete: function () {
           vm.videoStatus = 1
           if (vm.isBeforeLoading === false) {
              vm.videoStatus = 2
           }
        }
      })
    },
    handleSkipVideo (status) {
      this.isIntroducingShow = false
      this.isVideoShow = false
      this.isMenuShow = true
      if (this.isMenuPlay === false) {
        this.handleMenu('skip video')
        this.isMenuPlay = true
      }
      
      if (status === 'isPlaying') {
        window.ga("newmedia.send", {
          "hitType": "event",
          "eventCategory": "Button_main",
          "eventAction": "Click_main",
          "eventLabel": "[" + Utils.detectPlatform() + "] [" + document.querySelector('title').innerHTML + "][Video_Skip_main]"
        })
      }
      if (status === 'isNotPlaying') {
        window.ga("newmedia.send", {
          "hitType": "event",
          "eventCategory": "Opening_main",
          "eventAction": "Click_main",
          "eventLabel": "[" + Utils.detectPlatform() + "] [" + document.querySelector('title').innerHTML + "][Opening_Skip_main]"
        })
      }
      
    },
    handleIOS () {
      let result = Utils.iOSVersion(6)
      this.isIOS = result
      return result
    },
    handelMouseIn (whichList) {
      this.$set(this.nav[whichList], 'isActive', true)
      this.t2.pause()
      this.t3.pause()
    },
    handelMouseOut (whichList) {
      this.$set(this.nav[whichList], 'isActive', false)
      this.t2.play()
      this.t3.play()
    },
    handleOutlinkGA (target) {
      window.ga("newmedia.send", {
        "hitType": "event",
        "eventCategory": "Six Story",
        "eventAction": "Click_main",
        "eventLabel": "[" + Utils.detectPlatform() + "] [" + document.querySelector('title').innerHTML + "][ Story " + (target + 1) + " ]"
      })
    },
    detactVideoStatus () {
      let video = document.querySelector('#coverVideo');
      let vm = this;

      video.addEventListener('canplaythrough', function() {
        vm.isBeforeLoading = false
      }, false);

      video.load();
    },
    playVideo () {
      
      let vm = this
      let video = document.querySelector('#coverVideo');
      let currentRange = 0

      vm.isIntroducingShow = false
      vm.isVideoShow = true   

      video.addEventListener('ended', function () {
        vm.isVideoShow = false
        vm.isMenuShow = true
        if (vm.isMenuPlay === false) {
           vm.handleMenu('video End')
           vm.isMenuPlay = true
        }
      })
      
      video.addEventListener('timeupdate', function () {
        currentRange = Math.floor(video.currentTime / 3)
        if ( vm.videoProcess[currentRange] === false ) {
          vm.videoProcess[currentRange] = true
          window.ga("newmedia.send", {
            "hitType": "event",
            "eventCategory": "Video_main",
            "eventAction": "Play_main",
            "eventLabel": "[" + Utils.detectPlatform() + "][" + document.querySelector('title').innerHTML + "][" + vm.currentRangeName[currentRange] + "]"
          })
        }
      })

      video.pause();
      video.currentTime = 0;
      video.play();

      window.ga("newmedia.send", {
        "hitType": "event",
        "eventCategory": "Button_main",
        "eventAction": "Click_main",
        "eventLabel": "[" + Utils.detectPlatform() + "][" + document.querySelector('title').innerHTML + "][Button_Play_main]"
      })

    },
    handleMenu (status) {
      console.log(status)
      let vm =this
      this.t2 = anime.timeline({
        easing: 'easeOutExpo',
        duration: 750,
        loop: true
      });
      
      this.t2
      .add({
        targets: '.theme-list1',
        scale: 1.3,
        duration: 2000
      })
      .add({
        targets: '.theme-list1',
        scale: 1,
        duration: 500,
        complete: function () {
          vm.nav[0].isActive = false
        }
      })
      .add({
        targets: '.theme-list2',
        scale: 1.3,
        duration: 2000
      })
      .add({
        targets: '.theme-list2',
        scale: 1,
        duration: 500
      })
      .add({
        targets: '.theme-list3',
        scale: 1.3,
        duration: 2000
      })
      .add({
        targets: '.theme-list3',
        scale: 1,
        duration: 500
      })
      .add({
        targets: '.theme-list4',
        scale: 1.3,
        duration: 2000
      })
      .add({
        targets: '.theme-list4',
        scale: 1,
        duration: 500
      })
      .add({
        targets: '.theme-list5',
        scale: 1.3,
        duration: 2000
      })
      .add({
        targets: '.theme-list5',
        scale: 1,
        duration: 500
      })
      .add({
        targets: '.theme-list6',
        scale: 1.3,
        duration: 2000
      })
      .add({
        targets: '.theme-list6',
        scale: 1,
        duration: 500
      })
      .add({
        targets: '.theme-list5',
        scale: 1.3,
        duration: 2000
      })
      .add({
        targets: '.theme-list5',
        scale: 1,
        duration: 500
      })
      .add({
        targets: '.theme-list4',
        scale: 1.3,
        duration: 2000
      })
      .add({
        targets: '.theme-list4',
        scale: 1,
        duration: 500
      })
      .add({
        targets: '.theme-list3',
        scale: 1.3,
        duration: 2000
      })
      .add({
        targets: '.theme-list3',
        scale: 1,
        duration: 500
      })
      .add({
        targets: '.theme-list2',
        scale: 1.3,
        duration: 2000
      })
      .add({
        targets: '.theme-list2',
        scale: 1,
        duration: 500
      })
 

      this.t3 = anime.timeline({
        easing: 'easeOutExpo',
        duration: 750,
        loop: true
      });
      // Add children

      this.t3
      .add({
        targets: '.theme-list1-mark',
        opacity: 0.5,
        duration: 2000
      })
      .add({
        targets: '.theme-list1-mark',
        opacity: 0,
        duration: 500
      })
      .add({
        targets: '.theme-list2-mark',
        opacity: 0.5,
        duration: 2000
      })
      .add({
        targets: '.theme-list2-mark',
        opacity: 0,
        duration: 500
      })
      .add({
        targets: '.theme-list3-mark',
        opacity: 0.5,
        duration: 2000
      })
      .add({
        targets: '.theme-list3-mark',
        opacity: 0,
        duration: 500
      })
      .add({
        targets: '.theme-list4-mark',
        opacity: 0.5,
        duration: 2000
      })
      .add({
        targets: '.theme-list4-mark',
        opacity: 0,
        duration: 500
      })
      .add({
        targets: '.theme-list5-mark',
        opacity: 0.5,
        duration: 2000
      })
      .add({
        targets: '.theme-list5-mark',
        opacity: 0,
        duration: 500
      })
      .add({
        targets: '.theme-list6-mark',
        opacity: 0.5,
        duration: 2000
      })
      .add({
        targets: '.theme-list6-mark',
        opacity: 0,
        duration: 500
      })
      .add({
        targets: '.theme-list5-mark',
        opacity: 0.5,
        duration: 2000
      })
      .add({
        targets: '.theme-list5-mark',
        opacity: 0,
        duration: 500
      })
      .add({
        targets: '.theme-list4-mark',
        opacity: 0.5,
        duration: 2000
      })
      .add({
        targets: '.theme-list4-mark',
        opacity: 0,
        duration: 500
      })
      .add({
        targets: '.theme-list3-mark',
        opacity: 0.5,
        duration: 2000
      })
      .add({
        targets: '.theme-list3-mark',
        opacity: 0,
        duration: 500
      })
      .add({
        targets: '.theme-list2-mark',
        opacity: 0.5,
        duration: 2000
      })
      .add({
        targets: '.theme-list2-mark',
        opacity: 0,
        duration: 500
      })

    }
  },
  watch: {
    // 计算属性的 getter
    isBeforeLoading: function () {
      // `this` 指向 vm 实例
      console.log("it can play")
    }
  }
}
</script>

<style lang="scss">
@import "../../sass/main.scss";
@import "../share_scss/custom.scss";

@font-face {
    font-family: "ARMingB5ExtraBold";
    src: local('ARMingB5ExtraBold'),
    url(../share_source/ARMingB5ExtraBold.ttf);
}

#app {
  overflow: hidden;
  font-display: swap;
  
  background: center / cover no-repeat url('../share_source/background_mob.jpg');
  @media (min-width: 768px) and (max-width: 1279.98px) {
    background: center / cover no-repeat url('../share_source/background_pad.jpg');
  }
  @media (min-width: 1280px) {
    background: center / cover no-repeat url('../share_source/background_pc.jpg');
  }
  .forewords {
    
    width: 100%;
    height: 100vh;
    display: flex;
    position: relative;
    justify-content: center;
    align-items: flex-start;
    padding-top: 70px;
    @media (min-width: 768px) and (max-width: 1279.98px) {
       
    }
    @media (min-width: 1280px) {
      justify-content: center;
      align-items: center;
    }
    .foreword-content {
      font-family: 'ARMingB5ExtraBold';
      transform-origin: center center;
      -webkit-writing-mode: vertical-rl;
      writing-mode: vertical-rl;
      -webkit-text-orientation: upright;
      text-orientation: upright;
      letter-spacing: .7rem;
      display:none;
      opacity: 0;

      .fixIOS {
        padding-right: 20px;
        @media (min-width: 768px) and (max-width: 1279.98px) {
          // padding-right: 20px;
        }
        @media (min-width: 1280px) {
          padding-right: 0px;
        }
      }
      @media (min-width: 768px) and (max-width: 1279.98px) {
        padding-top: 169px;
        padding-right: 50px;
      }
      @media (min-width: 1280px) {
          -webkit-writing-mode: horizontal-tb;;
          writing-mode: horizontal-tb;
          color: black;
      }
      .beforeVideo {
        display: flex;
        align-items: center;
        flex-direction: column;
        position: relative;
        
        .playVideo {
          padding-top: 15px;
          -webkit-writing-mode: horizontal-tb;;
          writing-mode: horizontal-tb;
          color: $green;
          line-height: 1.3;
          letter-spacing: normal;
          font-size: 16px;
          font-family:'Microsoft JhengHei';
          cursor: pointer;
          display: flex;
          justify-content: center;
          flex-direction: column;
          .startPlay {
            font-size: 14px;
            margin: 10px 0 0 0;
            white-space:nowrap;
            @media (min-width: 768px) and (max-width: 1279.98px) {
              font-size: 16px;
            }
            @media (min-width: 1280px) {
              font-size: 16px;
            }
          }
        }
        .videoStatus {
          position: absolute;
          bottom: -70px;
          left: 50%;
          transform: translate(-50%, 0);
        }
        .loading {
          
          margin: 0px auto;
          border-radius: 50%;
          border: 4px solid  #f1f1f1;
          border-top: 4px solid $green;
          width: 40px;
          height: 40px;
          animation: 1.64s loading infinite linear;
          transform: translate(-50%, -50%)
        }
        @keyframes loading {
          0%{
            transform: rotate(0)
          }
          100%{
            transform: rotate(360deg)
          }
        }
      }
    }
  }
  .video-box {
    z-index: 10;
    transition: all 1s;
    // position: absolute;
    // top: 0;
    // left: 0;
    width: 100%;
    height: 100vh;
    position: relative;
    overflow: hidden;
    video {
      width: auto;
      height: 100%;
      object-fit: cover;
      @media (min-width: 768px) and (max-width: 1279.98px) {
        width: 100%;
        height: auto;
      }
      @media (min-width: 1280px) {
        width:100%;
        height: 100%;
      }
      &.fixIE {
         width:100vw;
         height: auto;
      }
    }
    .skip {
      position: absolute;
      left: 50%;
      bottom: 56px;
      transform: translateX(-50%);
      color: $gray;
      font-family:'Microsoft JhengHei';
      font-size: 14px;
      line-height: 1.3;
      letter-spacing: normal;
      cursor: pointer;
      opacity: 0;
      animation: fade .5s ease-in-out 1s 1 forwards;
      @media (min-width: 768px) and (max-width: 1279.98px) {
        font-size: 16px;
      }
      @media (min-width: 1280px) {
        font-size: 16px;
      }
    }
    @keyframes fade {
      from {opacity: 0;}
      to {opacity: 1;}
    }
  }
  .fade-enter-active, .fade-leave-active {
      transition: opacity 1s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
      opacity: 0
  }
  .menu {
    width: 100%;
    height: 100vh;
    display: flex;
    padding-top: 60px;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    font-family:'Microsoft JhengHei';
    transition: all 1s;
    background-image   : url('../public/images/background/rebuild_1.png'),
                       url('../public/images/background/rebuild_2.png');
    background-repeat  : no-repeat,
                       no-repeat;
    background-position: left 75%,
                         right 75%;
    background-size: 50%,  50%;
    
    @media (min-width: 768px) and (max-width: 1279.98px) {
        background-size: 50%,  50%;
    }
    @media (min-width: 1280px) {
      justify-content: center;
      background-size: 40%,  40%;
      background-position: left center ,
                        right center;
    }
    h1 {
      font-weight: bold;
      transition: all 1s;
    }
   
    .readMore {
      color: $green;
      padding: 5px 0 30px;
    }                
    .theme-lists {
      padding: 0;
      margin: 0;
      display: flex;
      justify-content: center;
      flex-direction: row-reverse;
      width: 100%;
      .theme-list {
        font-family:'Microsoft JhengHei', 'PMingLiU';
        transform-origin: top;
        padding: 0;
        margin: 0;
        list-style: none;
        -webkit-writing-mode: vertical-rl;
        writing-mode: vertical-rl;
        padding: 0 10px;
        cursor: pointer;
        position: relative;
        &.active {
          transition: opacity .5s !important;
          opacity: 0.7 !important;
          .mark {
            opacity: 0.7 !important;
          }
        }
        a {
          color: black;
          text-decoration: none;
          .theme-list-content {
            position: relative;
            .mark {
              opacity: 0;
              position: absolute;
              height: 105%;
              z-index: -1;
              top: 0px;
              left: 0px;
              border-left: solid 8px #57b09f;
            }
            .fixIOS {
              left: -75%;
            }
            .fixIE {
              top: 0;
              left: 0;
              z-index: 0;
            }
            .fixSAMSUNG {
              left: -10px;
            }
          }

        }
        
      }
    }
  }
}
</style>
